import classnames from 'classnames';
import React, { FunctionComponent, ReactNode } from 'react';

import { SortIcon, SortIconState } from './SortIcon';
import classes from './styles/api-keys-table.module.scss';
import { ApiKeySortColumn, ApiKeySortState } from './types';

interface SortableHeaderProps {
  children: ReactNode;
  column: ApiKeySortColumn;
  onSort: (column: ApiKeySortColumn) => void;
  sort: ApiKeySortState;
}

export const SortableHeader: FunctionComponent<SortableHeaderProps> = ({
  children,
  column,
  onSort,
  sort,
}) => {
  const isActive = sort.column === column;
  const iconState: SortIconState = isActive ? sort.direction : 'none';
  const ariaSort = isActive
    ? (sort.direction === 'asc' ? 'ascending' : 'descending')
    : 'none';

  return (
    <th aria-sort={ariaSort} className={classnames(classes.headerCell, classes.sortableHeaderCell)} scope="col">
      <button
        className={classes.sortButton}
        onClick={(): void => onSort(column)}
        type="button"
      >
        <span>{children}</span>
        <SortIcon state={iconState} />
      </button>
    </th>
  );
};
